module.exports = __webpack_public_path__ + "static/Softbank-294e15fe088cbb06055eb7dca068a794.svg";